<template>
  <div class="q-mx-lg " style="min-width: 1032px;">
    <h4 class="q-mt-xl q-mb-md text-white">Тестовый период завершен</h4>
    <p class="text-white q-mb-lg display-block">
      Дальнейшее использование сервиса возможно на коммерческой основе
    </p>
    <div class="overflow-hidden">
      <q-card
        class="my-card no-shadow pf-cards-small cardphys float-left q-mr-lg"
      >
        <q-card-section class="text-center">
          <div class="text-h6 q-mb-md row items-center justify-center no-wrap">
            Оплата по QR-коду
            <img
              src="~assets/sbp-logo.svg"
              style="height:28px;margin-left:8px;background:#fff;padding:4px;border-radius:6px"
            />
          </div>
          <TBank
            ref="tbankQR"
            :amount="114000"
            :email="userEmail"
            :payer-name="payerName"
            trigger-only
            @paid="onTBankPaid"
          />
          <TBankWidget
            class="q-mb-md"
            ref="tbankWidget"
            :amount="114000"
            :email="userEmail"
            :payer-name="payerName"
            trigger-only
          />
          <q-btn
            unelevated
            no-caps
            color="secondary"
            icon="qr_code_2"
            label="Показать QR-код"
            class="q-mb-sm"
            style="width:177px;margin-left:0;margin-bottom:32px"
            @click="onShowQR"
          />
          <q-btn
            unelevated
            no-caps
            color="yellow-8"
            text-color="black"
            icon="credit_card"
            label="Оплатить картой"
            class="q-mb-md"
            @click="onPayByCard"
          />
          <div class="text-subtitle2">
            <p>Для оплаты через мобильное приложение банка.</p>
            <p>
              <a
                class="text-yellow-6"
                href="/support/pay/payment-people/"
                target="_blank"
                >Инструкция по оплате.</a
              >
            </p>
          </div>
          <q-btn
            v-if="delaypeople == 0"
            unelevated
            class="q-mt-sm bg-primary full-width"
            icon="notifications_active"
            label="Я оплатил, срочно включите!"
            no-caps
            @click="getFreeDaysForQR"
          />
        </q-card-section>
      </q-card>
      <q-card
        class="my-card bg-primary-light no-shadow pf-cards cardjur float-left q-mr-lg"
      >
        <q-card-section>
          <div class="text-h6 q-mb-md">Оплата по счету</div>
          <div class="text-subtitle2">
            <p>
              После создания счета вам автоматически <br />добавится 10 дней.
            </p>
            <p>
              Вы сможете сразу продолжить работу, <br />не дожидаясь поступления
              оплаты.

              {{
                delaypayment == "1" ? " (Автопродление уже использовано)" : ""
              }}
            </p>
          </div>
        </q-card-section>

        <q-card-section class=" q-pt-none">
          <q-list>
            <q-item clickable>
              <q-item-section avatar>
                <q-avatar color="secondary">1</q-avatar>
              </q-item-section>

              <q-item-section>
                <q-item-label>Заполните реквизиты</q-item-label>
                <q-item-label class="text-yellow-1" caption lines="1"
                  >в меню "Реквизиты"</q-item-label
                >
              </q-item-section>

              <q-item-section side>
                <q-btn color="secondary" unelevated @click="showrecscompany"
                  >Заполнить</q-btn
                >
              </q-item-section>
            </q-item>
            <q-item class="q-my-sm" clickable>
              <q-item-section avatar>
                <q-avatar color="secondary">2</q-avatar>
              </q-item-section>

              <q-item-section>
                <q-item-label>Создайте новый счет</q-item-label>
                <q-item-label caption lines="1" class="text-yellow-1"
                  >в меню "Счета и акты"</q-item-label
                >
              </q-item-section>

              <q-item-section side>
                <q-btn color="secondary" unelevated @click="showbills"
                  >Создать</q-btn
                >
              </q-item-section>
            </q-item>
            <q-item class="q-my-sm" clickable>
              <q-item-section avatar>
                <q-avatar color="secondary" text-color="white">3</q-avatar>
              </q-item-section>

              <q-item-section>
                <q-item-label>Распечатайте счет</q-item-label>
                <q-item-label caption lines="1"></q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-card-section>
      </q-card>
      <q-card
        class="my-card no-shadow pf-cards-middle bg-primary float-left cardprice"
      >
        <q-card-section class="bg-primary-light">
          <div class="text-h6 q-mb-md">
            Стоимость использования сервиса
          </div>
          <div class="text-subtitle2">
            <p class="oldprice text-accent">1580 руб</p>
            <p class="newprice text-yellow">1140 руб</p>
            <p>
              Годовая лицензия <br />Количество компьютеров неограничено
              <br />Импорт адресов из EXCEL
            </p>
          </div>
          <q-card class="my-card bg-secondary no-shadow pf-cards card-h320">
            <q-card-section>
              <div class="text-h6 q-mb-xs" style="line-height: 140%;">
                Бесплатное использование сервиса доступно для организаций из
                сферы образования
              </div>
              <p class="q-mt-md">
                Для получения лицензии напишите в техподдержку
              </p>
            </q-card-section>
          </q-card>
        </q-card-section>
      </q-card>
    </div>
    <q-dialog
      v-model="delayforcompanies_dialog"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card
        class="bg-secondary text-white"
        style="width: 640px; max-width: 700px"
      >
        <q-card-section class="inventheader">
          <div class="text-h6">Новый счет создан</div>
        </q-card-section>

        <q-card-section>
          Вы создали новый счет. Ваш аккаунт автоматически продлен на 10 дней.
          <br />Чтобы продолжить работу распечатайте счет и обновите
          страницу.</q-card-section
        >

        <q-card-actions align="right" class="inventbtns text-white q-pa-md">
          <q-btn
            unelevated
            no-caps
            label="Распечатать счет"
            icon="print"
            @click="printBill"
            dense
            color="accent"
          />
          <q-btn
            unelevated
            no-caps
            label="Обновить страницу"
            @click="refreshPage"
            dense
            color="accent"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog
      v-model="showNameDialog"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card
        class="bg-primary-light text-white"
        style="width: 360px; max-width: 95vw"
      >
        <q-card-section class="q-pa-lg">
          <div class="text-h4 q-mb-md">Введите ФИО</div>
          <q-input
            v-model="payerName"
            dark
            color="yellow-5"
            dense
            label="ФИО плательщика"
            :disable="nameLoading"
            @keyup.enter="savePayerAndPay"
          />
          <q-btn
            unelevated
            no-caps
            color="secondary"
            label="Продолжить"
            class="full-width q-mt-lg"
            :loading="nameLoading"
            :disable="!payerName.trim()"
            @click="savePayerAndPay"
          />
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="delayforqr_dialog"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card
        class="bg-secondary text-white"
        style="width: 640px; max-width: 700px"
      >
        <q-card-section class="inventheader">
          <div class="text-h6">Аккаунт активирован</div>
        </q-card-section>

        <q-card-section>
          Платежи по QR-коду приходят на следующий рабочий день. <br />Мы
          активировали аккаунт на 2 дня, чтобы вы могли продолжить работу прямо
          сейчас. <br />Обновите страницу.</q-card-section
        >

        <q-card-actions align="right" class="inventbtns text-white q-pa-md">
          <q-btn
            unelevated
            no-caps
            label="Обновить страницу"
            @click="refreshPage"
            dense
            color="accent"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import TBank from "./TBank.vue";
import TBankWidget from "./TBankWidget.vue";

const LEGAL_ABBR = [
  "ООО",
  "ОАО",
  "ЗАО",
  "АО",
  "ИП",
  "ПАО",
  "НКО",
  "ГУП",
  "МУП",
  "ФГУП",
  "СНТ",
  "ТСЖ",
  "КПК",
  "НАО"
];
const LEGAL_KEYWORDS = [
  "общество",
  "предприниматель",
  "предприятие",
  "товарищество",
  "кооператив",
  "учреждение",
  "партнёрство",
  "партнерство",
  "корпорация",
  "фонд",
  "концерн",
  "холдинг",
  "ассоциация",
  "организация"
];

function looksLikeFIO(name) {
  if (!name || !name.trim()) return false;
  const lower = name.trim().toLowerCase();
  if (LEGAL_KEYWORDS.some(kw => lower.includes(kw))) return false;
  const words = name.trim().split(/\s+/);
  if (words.length < 2 || words.length > 3) return false;
  const upperWords = words.map(w => w.toUpperCase());
  if (LEGAL_ABBR.some(abbr => upperWords.includes(abbr))) return false;
  return words.every(w => /^[А-ЯЁ]([а-яёА-ЯЁ-]+|\.([А-ЯЁ]\.)?)$/.test(w));
}

export default {
  components: {
    TBank,
    TBankWidget
  },
  data() {
    return {
      tab: "company",
      delayforcompanies_dialog: false,
      delayforqr_dialog: false,
      showNameDialog: false,
      payerName: "",
      nameLoading: false,
      pendingAction: null
    };
  },
  computed: {
    userEmail() {
      return this.$store.getters.ACCOUNT.email || "";
    },
    showaccount: {
      get() {
        return this.$store.getters.SHOWACCOUNT;
      },
      set(value) {
        this.$store.commit("SET_SHOWACCOUNT", value);
      }
    },
    delaypayment() {
      return this.$store.getters.DELAYPAYMENT;
    },
    delaypeople() {
      return this.$store.getters.DELAYPEOPLE;
    }
  },
  methods: {
    showrecscompany() {
      this.showaccount = true;
      this.$eventBus.$emit("change-acc-tab", { tab: "req", ctype: "company" });
      //this.$eventBus.$emit("change-user-type", "company");
    },
    showrecspeople() {
      this.showaccount = true;
      this.$eventBus.$emit("change-acc-tab", { tab: "req", ctype: "people" });
      //this.$eventBus.$emit("change-user-type", "people");
    },
    showbills() {
      this.showaccount = true;
      this.$eventBus.$emit("change-acc-tab", { tab: "bills" });
    },
    showDelayInfoForCompanies() {},
    printBill() {
      this.$eventBus.$emit("print-last-bill");
    },
    refreshPage() {
      let l = "/";
      window.location = l;
    },
    getFreeDaysForQR() {
      this.$store.dispatch("GET_FREE_DAYS_FOR_QR", {
        action: "addfreedaysfromqr"
      });
    },
    onTBankPaid() {
      this.getFreeDaysForQR();
    },
    _checkAndPay(action) {
      const req = this.$store.getters.ACCOUNT.req || {};
      const inn = (req.inn || "").trim();
      const companyname = (req.companyname || "").trim();
      this.pendingAction = action;
      if (inn || !looksLikeFIO(companyname)) {
        this.payerName = "";
        this.showNameDialog = true;
      } else {
        this.payerName = companyname;
        this.savePayerAndPay();
      }
    },
    onPayByCard() {
      this._checkAndPay("card");
    },
    onShowQR() {
      this._checkAndPay("qr");
    },
    async savePayerAndPay() {
      if (!this.payerName.trim() || this.nameLoading) return;
      this.nameLoading = true;
      this.nameLoading = false;
      this.showNameDialog = false;
      await this.$nextTick();
      if (this.pendingAction === "qr") {
        this.$refs.tbankQR.start();
      } else {
        this.$refs.tbankWidget.openRedirect();
      }
    }
  },

  mounted() {
    this.$store.commit("LICENCE_FINISHED");
  },
  created() {
    this.unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === "SHOW_DIALOG_FREE_DAYS_ADDED") {
        this.delayforcompanies_dialog = true;
      } else if (mutation.type === "SHOW_DIALOG_FREE_DAYS_QR_ADDED") {
        this.delayforqr_dialog = true;
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
</script>

<style lang="sass">
.oldprice
  font-size: 32px
  text-decoration: line-through
  font-weight: 700
.newprice
  font-size: 22px
.cardphys
  width: 300px
  background-color: #9e0a47
.cardjur
  width: 380px
.cardprice
  width: 300px
</style>
